module.exports = __webpack_public_path__ + "img/ic_next_active.ad71ea96.svg";